import { useField, useFormikContext } from 'formik';

import { EnumMultiComboBox, type EnumMultiComboBoxProps } from '../../enums/EnumMultiComboBox';

interface FormikEnumMultiComboBoxProps extends Omit<EnumMultiComboBoxProps, 'value' | 'onChange'> {
    name: string;
}

export function FormikEnumMultiComboBox(props: FormikEnumMultiComboBoxProps) {
    const [field, meta, helpers] = useField<string[]>(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (options: string[]) => {
        helpers.setValue(options);
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <EnumMultiComboBox
            {...props}
            {...field}
            onChange={onChange}
            enumType={props.enumType}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
